import { capitalise } from './format';
export const humanReadableFloorNumber = (floorNumber) => {
    if (floorNumber == null) {
        return undefined;
    }
    if (floorNumber < 0) {
        return `Basement`;
    }
    if (floorNumber === 0) {
        return 'Ground floor';
    }
    const suffix = (n) => {
        const lastDigit = n % 10;
        if (n === 11 || n === 12 || n === 13)
            return 'th';
        if (lastDigit === 1)
            return 'st';
        if (lastDigit === 2)
            return 'nd';
        if (lastDigit === 3)
            return 'rd';
        return 'th';
    };
    return `${floorNumber}${suffix(floorNumber)} floor`;
};
const capitaliseFirstWord = (words) => {
    const [firstWord, ...rest] = words;
    return [capitalise(firstWord), ...rest];
};
export const getLocationPosition = (location) => {
    const floorNumber = humanReadableFloorNumber(location.floor_number);
    const positions = location.room_positions.map((p) => p.name.toLowerCase());
    const resultArray = [floorNumber, ...positions].filter((word) => word != null);
    return resultArray.length
        ? `${capitaliseFirstWord(resultArray).join(', ')}`
        : undefined;
};
